"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorInput = void 0;
var react_1 = __importDefault(require("react"));
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var css_1 = require("@emotion/css");
var errorStyles = function (selectedTheme) { return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  min-height: 21px;\n  flex-grow: 1;\n  align-self: flex-start;\n\n  svg {\n    padding-right: 4px;\n  }\n"], ["\n  ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  min-height: 21px;\n  flex-grow: 1;\n  align-self: flex-start;\n\n  svg {\n    padding-right: 4px;\n  }\n"])), (0, design_system_foundations_1.expandFontTheme)((0, design_system_foundations_1.addFontThemePrefix)(selectedTheme, 'metadata')), (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.red70, dark: design_system_foundations_1.theme.color.red30 })); };
var ErrorInput = function (_a) {
    var error = _a.error, testId = _a.testId, id = _a.id;
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    if (!error) {
        return null;
    }
    return (react_1.default.createElement("div", { id: id && "".concat(id, "-error"), className: errorStyles(selectedTheme), "data-testid": testId && "".concat(testId, "-error") },
        react_1.default.createElement(design_system_foundations_1.IconWarning, { size: "sm", color: "red50", testId: testId && "".concat(testId, "-error-icon") }),
        error));
};
exports.ErrorInput = ErrorInput;
var templateObject_1;
